import React, { useEffect, useRef, useState } from 'react';
import Header from '../Header';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import services from '../../services';
import dayjs from 'dayjs';
import moment from 'moment';
import axios from 'axios';
import { Modal, Button } from 'react-bootstrap';
import PropertySettingsModal from './PropertySettingsModal';
import { Droppable } from '@hello-pangea/dnd';
import TableSortDropdown from './TableSortDropdown';
import StatusDropdownTable from './StatusSelectTable';
import TagSelectTable from './TagDropdownTable';
const statusColors = [
    '#3b82f6',
    '#60a5fa',
    '#38bdf8',
    '#22d3ee',
    '#14b8a6',
    '#22c55e',
    '#a3e635',
    '#eab308',
    '#facc15',
    '#f59e0b',
    '#f97316',
    '#ef4444',
    '#ec4899',
    '#8b5cf6',
    '#a855f7',
    '#d1d5db',
    '#6b7280',
    '#374151',
    '#000000',
];

const TableData = ({
    columns,
    moveChildTask,
    taskMail,
    getTaskMail,
    selectedBoardId,
    setSortBy,
    setSortOrder,
    sortby,
    sortOrder,
}) => {
    const dispatch = useDispatch();
    const items = useSelector((state) => state);

    const [selectedColumnField, setSelectedColumnField] = useState(null);
    const [showPropertyModal, setShowPropertyModal] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [listFilter, setlistFilter] = useState(false);
    const [filterIdeas, setfilterIdeas] = useState(false);
    const [selectedListId, setSelectedListId] = useState('');
    const [title, setTitle] = useState('');
    const [userList, setUserList] = useState([]);
    const [taskitemasign, setTaskitemasign] = useState('');
    const [isSearchBoxOpen, setIsSearchBoxOpen] = useState(false);
    const [filteredTasksData, setFilteredTasksData] = useState([]);
    const [openUserDropdown, setOpenUserDropdown] = useState(false);
    const [customColumns, setCustomColumns] = useState([]);
    const [boardList, setBoardList] = useState([]);
    const [editingTaskId, setEditingTaskId] = useState(null);
    const [editTaskTitle, setEditTaskTitle] = useState('');
    const [taskTitle, setTaskTitle] = useState('');

    const getUserData = () => {
        try {
            const raw = localStorage.getItem("userData");
            if (!raw) return null;
            const parsed = JSON.parse(raw);
            return typeof parsed === "string" ? JSON.parse(parsed) : parsed;
        } catch (e) {
            console.error("Invalid userData in localStorage", e);
            return null;
        }
    };

    const userData = getUserData();

    const clickTimeoutRef = useRef(null);
    const ignoreNextClickRef = useRef(false);
    const openUserDropDownRef = useRef(null);
    const [openUserUpwards, setOpenUserUpwards] = useState(false);
    const [statusValues, setStatusValues] = useState(() => { });
    const [statusSearch, setStatusSearch] = useState('');
    const popupRef = useRef();

    const [isStatusColorModalOpen, setIsStatusModalColorOpen] = useState(false);
    const [inputStatusEditValue, setInputStatusValue] = useState('');
    const [selectedStatusColor, setSelectedStatusColor] = useState('');
    const [selectedStatusItem, setSelectedStatusItem] = useState({
        item: null,
        column: null,
    });
    const [selectedTagColor, setSelectedTagColor] = useState('#22c55e');
    const [selectedTagItem, setSelectedTagItem] = useState({
        item: null,
        column: null,
    });
    const [inputTagValue, setInputTagValue] = useState('');
    const modalRef = useRef();
    const tagModalRef = useRef();
    const [tagModalIndex, setTagModalIndex] = useState(null);
    const [defaultStatuses, setDefaultStatuses] = useState([]);
    const [defaultTags, setDefaultTags] = useState([]);
    const [propId, setPropId] = useState(null);
    const [selecteTagIndex, setSelecteTagIndex] = useState(null);
    const [allCustomFieldList, setAllCustomFieldList] = useState([]);
    const [editTagName, setEditTagName] = useState();
    const [customprokey, setCustomprokey] = useState([]);

    useEffect(() => {
        if (openUserDropdown && openUserDropDownRef.current) {
            const rect = openUserDropDownRef.current.getBoundingClientRect();
            const spaceBelow = window.innerHeight - rect.bottom;
            if (spaceBelow < 250) {
                setOpenUserUpwards(true);
            }
        }
    }, [openUserDropdown]);

    const listDropdown = () => {
        setlistFilter(!listFilter);
    };

    const filterOfIdeas = () => {
        setfilterIdeas(!filterIdeas);
    };

    const handlePropertyDelete = async (id) => {
        if (!id) return;
        try {
            const res = await services?.customfield.DELETE_PROPERTY(id);
            setShowPropertyModal(false);
            getPropertyByID(selectedBoardId);
        } catch (error) {
            console.error('Failed to add property:', error);
        }
    };

    const handleAddItem = async (event) => {
        event.preventDefault();

        let finalBoardId = selectedBoardId;
        if (!finalBoardId) {
            const savedBoard = getLocalStorageItem('board');
            if (savedBoard) {
                finalBoardId = typeof savedBoard === 'object' ? savedBoard.value : savedBoard;
            }
        }

        const { data } = await services.task.CREATE_TASK({
            subject: title,
            boardListId: selectedListId,
            boardId: finalBoardId,
            ...(userData?.role === "User" ? { userId: userData?.id } : {}),
        });

        const idData = items?.length > 0 ? items[items.length - 1].id + 1 : 1;

        const newItem = {
            id: idData,
            title: event.target.title.value,
            list: event.target.list.value,
            taskStatus: 'Open',
            assignedTo: (
                <span className="circle-user">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        className="bi bi-person"
                        viewBox="0 0 16 16"
                    >
                        <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
                    </svg>
                </span>
            ),
            created: 'Today',
            lastActivity: 'Today',
        };
        setItems(data?.data);
        getTaskMail();

        setIsModalOpen(false);
        event.target.reset();
    };

    const [addPropertyDetails, setPropertyDetails] = useState([]);
    const [customPropertyDetails, setCustomPropertyDetails] = useState([]);

    useEffect(() => {
        const columnDetails = columns?.map((item) => item?.id);
        const filteredTasks = taskMail?.all?.filter((item) => columnDetails?.includes(item?.BoardList?.id));
        const extractedAddProperties = filteredTasks?.map((task) => task?.addProperty).flat();
        setPropertyDetails(extractedAddProperties);
        setFilteredTasksData(filteredTasks);
        const extractedCustomProperties = filteredTasks?.map((task) => task?.customProperty || []).flat() || [];
        setCustomPropertyDetails((prev) => {
            const merged = [...prev, ...extractedCustomProperties];

            const unique = merged.filter(
                (prop, index, self) => index === self.findIndex((p) => p.selectedPropId === prop.selectedPropId),
            );

            return unique;
        });

        setCustomprokey(extractedCustomProperties);
    }, [columns, taskMail]);

    const getPropertyByID = async (boardId) => {
        try {
            const response = await services.property.GET_PROPERTY_BY_BOARD_ID(boardId);
            setCustomColumns(response?.data?.data);
        } catch (error) {
            console.error('Error fetching all users:', error);
        }
    };

    const getUserInitial = (userId) => {
        const matchedUser = userList.find((u) => u.id === userId);
        if (matchedUser && matchedUser.name) {
            return matchedUser.name.charAt(0).toUpperCase();
        }
        return null;
    };

    const openPropertySettingsModal = (columnFieldName) => {
        setShowPropertyModal(true);
        setSelectedColumnField(columnFieldName);
    };

    // getUserById effect removed, now using userList prop from AppViewer

    const handleToggleSearchBox = (itemData) => {
        setTaskitemasign(itemData);
        setIsSearchBoxOpen((prev) => !prev);
    };

    const assignUserToTask = async (taskId, user) => {
        const data = {
            userId: user.id,
        };
        try {
            const response = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/task/updateTask/${taskId}`, data);
            setFilteredTasksData((prevTasks) =>
                prevTasks.map((task) => (task.id === taskId ? { ...task, userId: user.id } : task)),
            );
            getTaskMail(1, '', selectedBoardId);
        } catch (error) {
            console.error('Error assigning user:', error);
        }
    };

    function getWeekdayLabel(dateString) {
        const inputDate = dayjs(dateString);
        const today = dayjs();
        const tomorrow = today.add(1, 'day');
        const formatDate = (d) => d.format('YYYY-MM-DD');
        if (formatDate(inputDate) === formatDate(today)) {
            return 'Today';
        }
        if (formatDate(inputDate) === formatDate(tomorrow)) {
            return 'Tomorrow';
        }
        const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const weekdayIndex = new Date(inputDate.toISOString()).getDay();
        return weekdays[weekdayIndex];
    }

    const handleTitleChange = (event) => {
        setTitle(event.target.value);
    };

    const formatDeadline = (deadline) => {
        if (!deadline) return '--';
        const date = moment(deadline);
        const today = moment();
        const tomorrow = moment().add(1, 'days');
        if (date.isSame(today, 'day')) {
            return 'Today';
        } else if (date.isSame(tomorrow, 'day')) {
            return 'Tomorrow';
        } else {
            return date.format('MMM DD, YYYY');
        }
    };

    const handleAddCustomColumn = (property) => {
        setCustomColumns((prev) => [...prev, property]);
        setShowPropertyModal(false);
    };

    const getAllBoardDateTable = async () => {
        try {
            const response = await services.board.GET_BOARD_LIST();
            setBoardList(response?.data?.data);
        } catch (error) {
            console.error('❌ Error fetching board date table:', error);
        }
    };

    const handleEmailDrop = async (draggedItem, droppedDate) => {
        try {
            const gmailMessageId =
                draggedItem?.gmailMessage ||
                draggedItem?.gmailMessageId ||
                draggedItem?.gmailMessageId ||
                draggedItem?.id;
            if (!gmailMessageId) {
                console.warn('❌ No Gmail Message ID found in dragged item:', draggedItem);
                return;
            }
            const selectedBoard = boardList.find((b) => b.id === selectedBoardId);

            if (!selectedBoard) {
                console.warn('❌ No board found for selectedBoardId:', selectedBoardId);
                return;
            }

            const defaultColumn = selectedBoard?.BoardLists?.find((item) => item?.sequence === 1);

            if (!defaultColumn) {
                console.warn('❌ No default column found in board:', selectedBoard);
                return;
            }

            const payload = {
                boardListId: defaultColumn?.id,
                title: '',
                taskType: 'Gmail',
                gmailMessageId: gmailMessageId,
                boardId: selectedBoardId,
                ...(userData?.role === "User" ? { userId: userData?.id } : {}),
            };

            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/task/createTask`, payload);

            getTaskMail(1, '', selectedBoardId);
        } catch (error) {
            console.error('❌ Task creation failed:', error);
        }
    };

    useEffect(() => {
        getAllBoardDateTable();
        getTaskMail(1, '', selectedBoardId);
        getPropertyByID(selectedBoardId);
    }, [selectedBoardId]);



    const handleAddItemTable = async (event) => {
        const selectedBoard = boardList.find((b) => b.id === selectedBoardId);
        if (!selectedBoard || !selectedBoard.BoardLists || selectedBoard.BoardLists.length === 0) {
            alert('No columns found for the selected board.');
            return;
        }

        const firstColumn = selectedBoard.BoardLists.find((col) => col.sequence === 1) || selectedBoard.BoardLists[0];

        if (!firstColumn) {
            alert('No columns found for the selected board.');
            return;
        }
        const dataObj = {
            boardListId: firstColumn.id,
            subject: 'type your task name here',
            boardId: selectedBoardId,
            ...(userData?.role === "User" ? { userId: userData?.id } : {}),
        };

        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/task/createTask`, dataObj);
            if (response) {
                getTaskMail(1, '', selectedBoardId);
            }
        } catch (error) {
            alert('Failed to create task.');
            console.error(error);
        }
    };

    const updateTaskMail = async (id, item) => {
        const data = {
            boardId: selectedBoardId,
            subject: editTaskTitle,
            boardListId: item?.BoardList?.id,
        };

        try {
            const response = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/task/updateTask/${id}`, data);
            if (response) {
                getTaskMail(1, '', selectedBoardId);
                setEditingTaskId(null);
                setEditTaskTitle('');
                setTaskTitle('');
            }
        } catch (error) {
            console.error(error, 'error');
        }
    };

    const handleDoubleClick = (item, e) => {
        if (clickTimeoutRef.current) {
            clearTimeout(clickTimeoutRef.current);
            clickTimeoutRef.current = null;
        }
        ignoreNextClickRef.current = true;
        if (item?.id) {
            setEditingTaskId(item.id);
            setEditTaskTitle(item?.title || item?.subject);
            setTaskTitle(item?.title || item?.subject);
        } else {
            setEditingTaskId(null);
            setEditTaskTitle('');
            setTaskTitle('');
        }
    };

    const [openEditModalCell, setOpenEditModalCell] = useState({ rowId: null, colId: null });
    const [editValue, setEditValue] = useState('');
    const [customFieldType, setCustomFieldType] = useState(null);
    const [allCustomField, setAllCustomField] = useState([]);
    const [selectedTags, setSelectedTags] = useState({});

    const getCustomPropertyById = async (id) => {
        try {
            await services.customfield.GET_CUSTOM_FIELD_BY_ID(id);
        } catch (error) {
            console.error('Error fetching all users:', error);
        }
    };

    const [tags, setTags] = useState(['test tag', 'hello']);
    const [input, setInput] = useState('');

    const handleUpdateCell = async (rowId, colId, newValue, col, color, idx) => {
        const data = {
            customPropertyId: colId,
            taskId: rowId,
            customField: {
                value: newValue,
                name: col?.property?.name,
                color: color,
            },
            index: idx,
        };

        let response;
        try {
            if (propId) {
                response = await services?.customfield.UPDATE_CUSTOM_FIELD(propId, data);
            } else {
                response = await services?.customfield.CREATE_CUSTOM_FIELD(data);
            }

            const customFieldPropertyDetails = response?.data?.data;

            if (customFieldPropertyDetails) {
                getAllPropertyByTaskId(colId, rowId, col?.property?.name);
                getCustomPropertyById(customFieldPropertyDetails?.id);
                getTaskMail(1, '', selectedBoardId);
                getAllCustomField();
            }
            setPropId(null);
        } catch (error) {
            console.error('Error updating or creating custom field:', error);
        }
    };


    const handleUpdatedCustomField = async (rowId, colId, newValue, col, color, idx) => {
        const data = {
            customPropertyId: colId,
            taskId: rowId,
            customField: {
                value: newValue,
                name: col?.property?.name,
                color: color,
            },
        };

        const response = await services?.customfield.UPDATE_CUSTOM_FIELD(propId, data);
        const customFieldPropertyDetails = response?.data?.data;
        getCustomPropertyById(customFieldPropertyDetails?.id);
        getAllPropertyByTaskId(colId, rowId, col?.property?.name);
        setPropId(null);
        getAllCustomField();
        setOpenEditModalCell({ rowId: null, colId: null });
    };
    const handleSelecteTag = (taskId, propertyId, value, col, color, tagIndex) => {

        const finalLabel = typeof value === 'object' ? value.label : value;
        const updatedValues = [
            {
                label: finalLabel,
                color,
            },
        ];

        const newTagObj = {
            name: 'Tag',
            value: updatedValues,
        };

        handleUpdateCell(taskId, propertyId, updatedValues, col, color);

    };

    const addTag = (e) => {
        e.preventDefault();
        const value = input.trim();
        if (value && !tags.includes(value)) {
            setTags([...tags, value]);
        }
        setInput('');
    };

    const handleSelectStatus = (taskId, customPropertyId, newValue, col, color, idx) => {
        const updatedStatus = {
            [customPropertyId]: newValue,
        };

        setStatusValues((prev) => ({
            ...prev,
            [taskId]: updatedStatus,
        }));
        if (propId) {
            handleUpdatedCustomField(taskId, customPropertyId, newValue, col, color, idx);
        } else {
            handleUpdateCell(taskId, customPropertyId, newValue, col, color, idx);
        }
    };

    const getAllCustomField = async () => {
        try {
            const response = await services.customfield.GET_ALL_CUSTOM_FIELD();
            const data = response?.data?.data || [];
            const defaultStatus = data.filter((f) => f?.customField?.name === 'Status');
            const defaultTag = data.filter((f) => f?.customField?.name === 'Tag');
            setAllCustomField(data);
        } catch (error) {
            console.error('Error fetching custom fields:', error);
        }
    };

    const getAllPropertyByTaskId = async (propertyId, taskId, item) => {
        try {
            const response = await services.customfield.GET_CUSTOM_FIELD_BY_TASK_ID(propertyId);
            const data = response?.data?.data || [];
            const defaultStatus = data.filter((f) => f?.customField?.name === 'Status');
            const defaultTag = data.filter((f) => f?.customField?.name === 'Tag');
            if (item?.customField?.name === 'Status' || item === 'Status' || item?.property?.name === 'Status') {
                setDefaultStatuses(defaultStatus);
            }
            if (item?.customField?.name === 'Tag' || item === 'Tag' || item?.property?.name === 'Tag') {
                setDefaultTags(defaultTag);
            }
        } catch (error) {
            console.error('Error fetching task custom fields:', error);
        }
    };

    const [open, setOpen] = useState(false);
    const menuRef = useRef(null);
    const titleMenuRef = useRef(null);
    const listMenuRef = useRef(null);
    const [openDropdown, setOpenDropdown] = useState(null);
    const [openDropdownIndex, setOpenDropdownIndex] = useState(null);

    const toggleDropdown = (name) => {
        setOpenDropdown((prev) => (prev === name ? null : name));
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setOpenDropdown(null);
                setOpenDropdownIndex(null);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleTableSort = (sortByField, order) => {
        if (!sortByField) return;

        let field = sortByField;

        if (typeof sortByField === 'object' && sortByField !== null) {
            field = sortByField?.property?.propertyName;
        }
        setSortBy(field);
        setSortOrder(order);
        setOpenDropdown(null);
    };


    useEffect(() => {
        if (sortby && sortOrder) {
            getTaskMail(1, '', selectedBoardId);
        }
    }, [sortby, sortOrder]);

    const tableBodyRef = useRef(null);
    const isDeletingRef = useRef(false);
    const hasInteractedRef = useRef(false);
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (isDeletingRef.current) return;
            const modalNode = modalRef.current;
            const popupNode = popupRef.current;
            const tableBodyNode = tableBodyRef.current;
            const clickedOutsideModal = modalNode && !modalNode.contains(e.target);
            const clickedOutsideParent = popupNode && !popupNode.contains(e.target);
            const clickedTableBody = tableBodyNode && tableBodyNode.contains(e.target);

            if (isModalOpen && clickedOutsideModal) {
                if (hasInteractedRef.current && selectedStatusItem.item && selectedStatusItem.column) {
                    handleSelectStatus(
                        selectedStatusItem.item,
                        selectedStatusItem.column.id,
                        inputStatusEditValue,
                        selectedStatusItem.column,
                        selectedStatusColor,
                    );
                    setOpenEditModalCell({ rowId: null, colId: null });
                }
                setIsModalOpen(false);
                hasInteractedRef.current = false;
                return;
            }

            if (tagModalIndex !== null && clickedOutsideParent) {
                if (selectedTagItem?.item && selectedTagItem?.column) {
                    handleSelecteTag(
                        selectedTagItem.item,
                        selectedTagItem.column.id,
                        inputTagValue,
                        selectedTagItem.column,
                        selectedTagColor,
                        selecteTagIndex,
                    );
                    setOpenEditModalCell({ rowId: null, colId: null });
                }
                setTagModalIndex(null);
                return;
            }

            if (clickedTableBody && selectedStatusItem.item && selectedStatusItem.column) {
                if (hasInteractedRef.current) {
                    handleSelectStatus(
                        selectedStatusItem.item,
                        selectedStatusItem.column.id,
                        inputStatusEditValue,
                        selectedStatusItem.column,
                        selectedStatusColor,
                    );
                    setOpenEditModalCell({ rowId: null, colId: null });
                    hasInteractedRef.current = false;
                }
                return;
            }

            if (openEditModalCell?.rowId && openEditModalCell?.colId && clickedOutsideParent) {
                setOpenEditModalCell({ rowId: null, colId: null });
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        isModalOpen,
        tagModalIndex,
        openEditModalCell?.rowId,
        openEditModalCell?.colId,
        selectedStatusItem,
        inputStatusEditValue,
        selectedStatusColor,
        selectedTagItem,
        inputTagValue,
        selectedTagColor,
        propId,
    ]);

    const deleteCustomField = async (id, val, item) => {
        const column = item?.column || {};
        const propertyName = column.property === 'Tag' ? 'Tag' : 'Status';
        const propertyId = column.id || item?.id;
        const taskId = column.taskId || item?.taskId;

        try {
            await services?.customfield.DELETE_CUSTOEM_FILED(id);
            getAllPropertyByTaskId(propertyId, taskId, propertyName);
            getTaskMail(1, '', selectedBoardId);
            getAllCustomField();
            setTagModalIndex(null);
            setIsModalOpen(false);
            setOpenEditModalCell({ rowId: null, colId: null });
        } catch (error) {
            console.error('Failed to delete custom field or fetch properties', error);
        }
    };

    useEffect(() => {
        getAllCustomField();
    }, [selectedBoardId]);

    const defaultColorMap = {
        Done: '#4ade80',
        'Working on': '#facc15',
        Stuck: '#f87171',
        'Waiting for approval': '#60a5fa',
        default: '#9ca3af',
    };

    const getDefaultColorByValue = (value) => {
        return defaultColorMap[value] || defaultColorMap.default;
    };

    const getTagLabelByIdStatus = (dataArray, id) => {
        const matchedItem = dataArray.find((item) => item.id === id);
        return matchedItem?.customField?.value || null;
    };

    const getTagLabelColorByIdStatus = (dataArray, id) => {
        const matchedItem = dataArray.find((item) => item.id === id);
        return matchedItem?.customField?.color || null;
    };

    const getTagLabelByIdTag = (dataArray, id) => {
        const matchedItem = dataArray.find((item) => item.id === id);
        return matchedItem?.customField?.value?.[0]?.label || null;
    };

    const getTagLabelColorByIdTag = (dataArray, id) => {
        const matchedItem = dataArray.find((item) => item.id === id);
        return matchedItem?.customField?.value?.[0]?.color || null;
    };

    function findBySelectedPropId(id, customProperty) {
        return customProperty.find((item) => item.selectedPropId === id);
    }

    const updateCustomProKey = (item, fieldId, newSelected, taskItem) => {
        const propertyName = item?.property?.name;
        if (!propertyName) return;

        let updated = [...customprokey];

        const exists = updated.find((obj) => obj.taskId === taskItem.id && obj.selectedPropId === item.id);

        if (propertyName === 'Tag') {
            const idArray = newSelected.map((sel) => sel.id);

            if (exists) {
                updated = updated.map((obj) =>
                    obj.taskId === taskItem.id && obj.selectedPropId === item.id
                        ? { ...obj, selectedFieldId: idArray }
                        : obj,
                );
            } else {
                updated.push({
                    taskId: taskItem.id,
                    selectedPropId: item.id,
                    selectedFieldId: idArray,
                });
            }
        } else if (propertyName === 'Status') {
            if (exists) {
                updated = updated.map((obj) =>
                    obj.taskId === taskItem.id && obj.selectedPropId === item.id
                        ? { ...obj, selectedFieldId: [fieldId] }
                        : obj,
                );
            } else {
                updated.push({
                    taskId: taskItem.id,
                    selectedPropId: item.id,
                    selectedFieldId: [fieldId],
                });
            }
        }

        const seen = new Map();
        updated.forEach((obj) => {
            const key = obj.taskId + '-' + obj.selectedPropId;
            seen.set(key, obj);
        });
        updated = Array.from(seen.values());

        setCustomprokey(updated);

        const payload = updated.filter((obj) => obj.taskId === taskItem.id).map(({ taskId, ...rest }) => rest);

        handletaskUpdate(payload, taskItem);
    };

    const handletaskUpdate = async (customProperty, taskItem) => {
        let obj = [...customprokey];

        if (customProperty && customProperty.length > 0) {
            const updatedPropIds = customProperty.map((p) => p.selectedPropId);

            obj = [
                ...obj.filter((p) => !(p.taskId === taskItem.id && updatedPropIds.includes(p.selectedPropId))),

                ...customProperty.map((p) => ({ ...p, taskId: taskItem.id })),
            ];
        }

        const data = {
            customProperty: obj.filter((p) => p.taskId === taskItem.id),
        };

        try {
            const response = await services.task.UPDATE_TASK(taskItem?.id, data);
            const updatedProperties = response?.data?.data?.customProperty ?? [];
            getTaskMail(1, '', selectedBoardId);
            getAllCustomField();
            setCustomprokey(updatedProperties);
            setOpenEditModalCell({ rowId: null, colId: null });
        } catch (err) {
            console.error('Failed to update SLA tags', err);
        }
    };

    const handleRemoveCustomField = async (id, task) => {
        const updatedTaskData = task?.customProperty?.map((item) => {
            return {
                ...item,
                selectedFieldId: item?.selectedFieldId?.filter((fieldId) => fieldId !== id),
            };
        });

        handletaskUpdate(updatedTaskData, task);
    };

    return (
        <Droppable droppableId="table-view">
            {(provided, snapshot) => (
                <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    style={{ opacity: snapshot.isDraggingOver ? 0.5 : 1 }}
                >
                    <div class="w-full max-h-[100vh] min-h-[100vh] overflow-y-auto">
                        <table class="w-full text-sm text-left text-gray-700 border border-gray-200">
                            <thead class="text-xs text-gray-700 uppercase bg-gray-100 sticky top-0 z-10">
                                <tr>
                                    <th
                                        scope="col"
                                        className="px-6 py-3 w-40 max-w-40 truncate whitespace-nowrap overflow-hidden"
                                    >
                                        <div className="relative flex align-items-center g-2 justify-content-between">
                                            <div className="flex g-2">
                                                <span> Title </span>
                                                <div
                                                    className="flex flex-col ml-1 cursor-pointer"
                                                    onClick={() => toggleDropdown('title')}
                                                >
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="8"
                                                        height="8"
                                                        fill="currentColor"
                                                        className="bi bi-chevron-up-fill"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                                                    </svg>
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="8"
                                                        height="8"
                                                        fill="currentColor"
                                                        className="bi bi-chevron-down-fill"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                                                    </svg>
                                                </div>
                                            </div>
                                            <button
                                                onClick={handleAddItemTable}
                                                className="ml-4 bg-blue-500 text-white font-semibold px-2 py-1 rounded text-xs hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300"
                                            >
                                                Add Item
                                            </button>
                                            {openDropdown === 'title' && (
                                                <div
                                                    ref={menuRef}
                                                    className="absolute top-full  z-10 mt-2 bg-white border shadow-md rounded-md w-40 text-sm"
                                                >
                                                    <TableSortDropdown
                                                        fieldName={openDropdown}
                                                        handleTableSort={handleTableSort}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </th>

                                    <th scope="col" className="px-6 py-3">
                                        <div className="relative">
                                            <div className="flex items-center space-x-1">
                                                <span>List</span>
                                                <div
                                                    className="flex flex-col ml-1 cursor-pointer"
                                                    onClick={() => toggleDropdown('list')}
                                                >
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="8"
                                                        height="8"
                                                        fill="currentColor"
                                                        className="bi bi-chevron-up-fill"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                                                    </svg>
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="8"
                                                        height="8"
                                                        fill="currentColor"
                                                        className="bi bi-chevron-down-fill"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                                                    </svg>
                                                </div>
                                            </div>

                                            {openDropdown === 'list' && (
                                                <div
                                                    ref={menuRef}
                                                    className="absolute top-full right-0 z-10 mt-2 bg-white border shadow-md rounded-md w-40 text-sm"
                                                >
                                                    <TableSortDropdown
                                                        fieldName="boardList"
                                                        handleTableSort={handleTableSort}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </th>

                                    <th scope="col" class="px-6 py-3">
                                        <div
                                            class="flex items-center space-x-1 relative"
                                            onClick={() => toggleDropdown('assignTo')}
                                        >
                                            <span>Assigned To</span>
                                            <div class="flex flex-col ml-1">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="8"
                                                    height="8"
                                                    fill="currentColor"
                                                    class="bi bi-chevron-up-fill"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                                                </svg>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="8"
                                                    height="8"
                                                    fill="currentColor"
                                                    class="bi bi-chevron-down-fill"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                                                </svg>
                                            </div>

                                            {openDropdown === 'assignTo' && (
                                                <div
                                                    ref={menuRef}
                                                    className="absolute top-full right-0 z-10 mt-2 bg-white border shadow-md rounded-md w-40 text-sm"
                                                >
                                                    <TableSortDropdown fieldName="user" handleTableSort={handleTableSort} />
                                                </div>
                                            )}
                                        </div>
                                    </th>
                                    <th scope="col" class="px-6 py-3">
                                        <div
                                            class="flex items-center space-x-1 relative"
                                            onClick={() => toggleDropdown('dueDate')}
                                        >
                                            <span>Due Date</span>
                                            <div class="flex flex-col ml-1">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="8"
                                                    height="8"
                                                    fill="currentColor"
                                                    class="bi bi-chevron-up-fill"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                                                </svg>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="8"
                                                    height="8"
                                                    fill="currentColor"
                                                    class="bi bi-chevron-down-fill"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                                                </svg>
                                            </div>

                                            {openDropdown === 'dueDate' && (
                                                <div
                                                    ref={menuRef}
                                                    className="absolute top-full right-0 z-10 mt-2 bg-white border shadow-md rounded-md w-40 text-sm"
                                                >
                                                    <TableSortDropdown fieldName="deadline" handleTableSort={handleTableSort} />
                                                </div>
                                            )}
                                        </div>
                                    </th>

                                    <th scope="col" class="px-6 py-3">
                                        <div
                                            class="flex items-center space-x-1 relative"
                                            onClick={() => toggleDropdown('createdAt')}
                                        >
                                            <span>Created</span>
                                            <div class="flex flex-col ml-1">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="8"
                                                    height="8"
                                                    fill="currentColor"
                                                    class="bi bi-chevron-up-fill"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                                                </svg>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="8"
                                                    height="8"
                                                    fill="currentColor"
                                                    class="bi bi-chevron-down-fill"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                                                </svg>
                                            </div>
                                            {openDropdown === 'createdAt' && (
                                                <div
                                                    ref={menuRef}
                                                    className="absolute top-full right-0 z-10 mt-2 bg-white border shadow-md rounded-md w-40 text-sm"
                                                >
                                                    <TableSortDropdown
                                                        fieldName="createdAt"
                                                        handleTableSort={handleTableSort}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </th>
                                    <th scope="col" class="px-6 py-3">
                                        <div
                                            class="flex items-center space-x-1 relative"
                                            onClick={() => toggleDropdown('updatedAt')}
                                        >
                                            <span>Last Email</span>
                                            <div class="flex flex-col ml-1">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="8"
                                                    height="8"
                                                    fill="currentColor"
                                                    class="bi bi-chevron-up-fill"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                                                </svg>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="8"
                                                    height="8"
                                                    fill="currentColor"
                                                    class="bi bi-chevron-down-fill"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                                                </svg>
                                            </div>
                                            {openDropdown === 'updatedAt' && (
                                                <div
                                                    ref={menuRef}
                                                    className="absolute top-full right-0 z-10 mt-2 bg-white border shadow-md rounded-md w-40 text-sm"
                                                >
                                                    <TableSortDropdown
                                                        fieldName="updatedAt"
                                                        handleTableSort={handleTableSort}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </th>
                                    {customColumns.map((col, idx) => (
                                        <th key={idx} scope="col" className="px-6 py-3">
                                            <div className="flex items-center justify-center space-x-1 relative">
                                                <span className="truncate">{col?.property?.propertyName}</span>
                                                <div className="flex flex-col" onClick={() => setOpenDropdownIndex(idx)}>
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="8"
                                                        height="8"
                                                        fill="currentColor"
                                                        className="bi bi-chevron-up-fill"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                                                    </svg>
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="8"
                                                        height="8"
                                                        fill="currentColor"
                                                        className="bi bi-chevron-down-fill"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                                                    </svg>
                                                </div>
                                                {openDropdownIndex === idx && (
                                                    <div
                                                        ref={menuRef}
                                                        className="absolute top-full right-0 mt-2 bg-white border shadow-md rounded-md w-40 text-sm"
                                                    >
                                                        <TableSortDropdown
                                                            fieldName={col}
                                                            handleTableSort={handleTableSort}
                                                            onOpenPropertySettingsModal={openPropertySettingsModal}
                                                            showPropertySettings={true}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </th>
                                    ))}
                                    <th scope="col" className="px-6 py-3">
                                        <div className="col-auto text-center text-black flex justify-center items-center gap-[10px] ">
                                            <button
                                                className="ml-2 p-1 rounded-full bg-[#1976d2] text-white hover:bg-[#1251a3]"
                                                title="Add Property"
                                                onClick={() => {
                                                    setShowPropertyModal((prev) => !prev), setSelectedColumnField('');
                                                }}
                                            >
                                                <svg width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                                                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                                </svg>
                                            </button>

                                            {showPropertyModal && (
                                                <PropertySettingsModal
                                                    show={showPropertyModal}
                                                    onClose={() => setShowPropertyModal(false)}
                                                    onSave={handleAddCustomColumn}
                                                    selectedBoardId={selectedBoardId}
                                                    getPropertyByID={getPropertyByID}
                                                    setShowPropertyModal={setShowPropertyModal}
                                                    selectedColumnField={selectedColumnField}
                                                    onDelete={handlePropertyDelete}
                                                />
                                            )}
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="bg-white divide-y divide-gray-200" ref={tableBodyRef}>
                                {filteredTasksData?.length === 0 ? (
                                    <tr>
                                        <td colSpan="10" className="px-6 py-4 text-center text-gray-500">
                                            No tasks found — Drag emails here to create tasks
                                        </td>
                                    </tr>
                                ) : (
                                    filteredTasksData?.map((item, index) => (
                                        <tr key={index} className="h-[87px]">
                                            <td className="px-6 py-3 w-40 max-w-80 truncate whitespace-nowrap overflow-hidden">
                                                {editingTaskId === item.id ? (
                                                    <input
                                                        type="text"
                                                        value={editTaskTitle}
                                                        autoFocus
                                                        onChange={(e) => setEditTaskTitle(e.target.value)}
                                                        onBlur={() => {
                                                            updateTaskMail(item.id, item), getTaskMail(1, '', selectedBoardId);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (
                                                                e.key === 'Enter' &&
                                                                (!e.shiftKey || customFieldType !== 'Text Double Line')
                                                            ) {
                                                                e.preventDefault();
                                                                handleUpdateCell(item.id, item.id, editValue, item);
                                                            }
                                                            if (e.key === 'Escape') {
                                                                setOpenEditModalCell({ rowId: null, colId: null });
                                                            }
                                                        }}
                                                        className="w-full border rounded p-1"
                                                    />
                                                ) : (
                                                    <span
                                                        onDoubleClick={(e) => handleDoubleClick(item, e)}
                                                        title={item.subject || 'N/A'}
                                                        className="block truncate"
                                                    >
                                                        {item.subject || 'N/A'}
                                                    </span>
                                                )}
                                            </td>
                                            <td className="px-4 py-2 border text-center">
                                                <button
                                                    className={`
                                             ${item.list === 'Ideas'
                                                            ? 'bg-[#8BC34A]'
                                                            : item.list === 'Planned'
                                                                ? 'bg-[#00BCD4]'
                                                                : item.list === 'In progress'
                                                                    ? 'bg-[#FF5722]'
                                                                    : item.list === 'Done'
                                                                        ? 'bg-[#9C27B0]'
                                                                        : ''
                                                        }
                                          text-dark px-2 py-1 rounded whitespace-nowrap
                                                                                       `}
                                                >
                                                    {item?.BoardList?.coloum || item.title}
                                                </button>
                                            </td>

                                            <td className="px-4 py-2 border ">
                                                <div className="relative flex flex-col items-center">
                                                    <div
                                                        className="cursor-pointer bg-[#1660c8] text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-semibold"
                                                        ref={openUserDropDownRef}
                                                        onClick={() =>
                                                            setOpenUserDropdown(openUserDropdown === index ? null : index)
                                                        }
                                                        title={item?.assignedTo || 'Unassigned'}
                                                    >
                                                        {getUserInitial(item?.userId) ? (
                                                            <span
                                                                className="w-7 h-7 flex items-center justify-center text-white rounded-full text-xs font-bold"
                                                                style={{
                                                                    backgroundColor: statusColors[
                                                                        item?.userId.charCodeAt(0) % statusColors?.length
                                                                    ],
                                                                }}
                                                            >
                                                                {getUserInitial(item?.userId)}
                                                            </span>
                                                        ) : (
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                className="w-7 h-7 p-1 rounded-full text-gray-500 bg-gray-200"
                                                                fill="currentColor"
                                                                viewBox="0 0 16 16"
                                                            >
                                                                <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 100-6 3 3 0 000 6z" />
                                                            </svg>
                                                        )}

                                                    </div>

                                                    {openUserDropdown === index && (
                                                        <div
                                                            className={`absolute top-full mt-1 right-0 z-40 w-[220px] max-h-[250px] bg-white shadow-xl border border-gray-300 rounded-lg overflow-hidden animate-fade-in`}
                                                        >
                                                            <div className="flex justify-between items-center px-3 py-2 border-b border-gray-200 bg-gray-50">
                                                                <span className="text-sm font-medium text-gray-700">
                                                                    Assign User
                                                                </span>
                                                                <button
                                                                    onClick={() => setOpenUserDropdown(null)}
                                                                    className="text-gray-400 hover:text-gray-600"
                                                                >
                                                                    ✕
                                                                </button>
                                                            </div>

                                                            <div className="max-h-[200px] overflow-y-auto">
                                                                {userList.length > 0 ? (
                                                                    userList.map((user, index) => (
                                                                        <div
                                                                            key={user.id}
                                                                            onClick={() => {
                                                                                assignUserToTask(item.id, user);
                                                                                setOpenUserDropdown(null);
                                                                            }}
                                                                            className="flex items-center px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                                                        >
                                                                            <div
                                                                                className="w-7 h-7 flex items-center justify-center text-white rounded-full text-xs font-bold mr-3"
                                                                                style={{
                                                                                    backgroundColor: statusColors[index % statusColors.length],
                                                                                }}
                                                                            >
                                                                                {user.name?.[0]?.toUpperCase() || user.email?.[0]?.toUpperCase()}
                                                                            </div>
                                                                            <div className="flex-1 text-sm text-gray-800 truncate">
                                                                                {user.name}
                                                                            </div>
                                                                        </div>
                                                                    ))
                                                                ) : (
                                                                    <div className="px-4 py-3 text-sm text-gray-500 text-center">
                                                                        No users found
                                                                    </div>
                                                                )}
                                                            </div>

                                                        </div>
                                                    )}
                                                </div>
                                            </td>
                                            <td className="px-4 py-2 border">{formatDeadline(item.deadline)}</td>

                                            <td className="px-4 py-2 border">{getWeekdayLabel(item.createdAt)}</td>

                                            <td className="px-4 py-2 border">{getWeekdayLabel(item.updatedAt)}</td>
                                            {customColumns.map((col, idx) => {
                                                const prop = Array.isArray(allCustomField)
                                                    ? allCustomField.find(
                                                        (p) => p.customPropertyId === col.id && p.taskId === item.id,
                                                    )
                                                    : null;

                                                const value = prop?.customField?.value || '';
                                                const customFieldName = col?.property?.name || '';
                                                const isEditing =
                                                    openEditModalCell.rowId === item.id && openEditModalCell.colId === col.id;

                                                const selectedFieldId = item?.customProperty?.flatMap(
                                                    (cp) => cp?.selectedFieldId || [],
                                                );

                                                const filteredFieldDetails = allCustomField.filter(
                                                    (ele) => ele.customPropertyId == col?.id,
                                                );
                                                return (
                                                    <td
                                                        key={col.id}
                                                        className="px-4 py-2 border "
                                                        style={{ overflow: 'visible' }}
                                                    >
                                                        <div
                                                            onClick={() => {
                                                                getAllPropertyByTaskId(col.id, '', col);
                                                                setOpenEditModalCell({ rowId: item.id, colId: col.id });
                                                                setEditValue(value);
                                                                setCustomFieldType(customFieldName);
                                                                if (customFieldName === 'Tag' && Array.isArray(value)) {
                                                                    setSelectedTags(selectedTags);
                                                                }
                                                            }}
                                                            className="cursor-pointer relative flex items-center gap-[5px]"
                                                        >
                                                            {isEditing && (
                                                                <div
                                                                    ref={popupRef}
                                                                    className="absolute top-full left-1/2 -translate-x-1/2 mt-1 z-40 "
                                                                >
                                                                    {customFieldType === 'Tag' && (
                                                                        <div
                                                                            style={{
                                                                                width: 300,
                                                                                background: '#fff',

                                                                                padding: 12,
                                                                            }}
                                                                        >
                                                                            <TagSelectTable
                                                                                item={col}
                                                                                idx={idx}
                                                                                taskItem={item}
                                                                                statusColors={statusColors}
                                                                                tagFieldsData={defaultTags}
                                                                                selectedTags={selectedTags}
                                                                                handleSelecteTag={handleSelecteTag}
                                                                                setSelectedTagColor={setSelectedTagColor}
                                                                                customeFiedId={propId}
                                                                                setCustomeFieldId={setPropId}
                                                                                deleteCustomField={deleteCustomField}
                                                                                editTagName={editTagName}
                                                                                setEditTagName={setEditTagName}
                                                                                handletaskUpdate={handletaskUpdate}
                                                                                customprokey={customprokey}
                                                                                setCustomprokey={setCustomprokey}
                                                                                updateCustomProKey={updateCustomProKey}
                                                                                selectedFieldId={selectedFieldId}
                                                                                handleUpdatedCustomField={
                                                                                    handleUpdatedCustomField
                                                                                }
                                                                            />
                                                                        </div>
                                                                    )}

                                                                    {customFieldType === 'Status' && (
                                                                        <div>
                                                                            <StatusDropdownTable
                                                                                StatusFields={defaultStatuses}
                                                                                openEditModalCell={openEditModalCell}
                                                                                item={col}
                                                                                taskItem={item}
                                                                                selectedFieldId={selectedFieldId}
                                                                                updateCustomProKey={updateCustomProKey}
                                                                                handletaskUpdate={handletaskUpdate}
                                                                                customprokey={customprokey}
                                                                                setCustomprokey={setCustomprokey}
                                                                                handleSelectStatus={handleSelectStatus}
                                                                                deleteCustomField={deleteCustomField}
                                                                                customeFiedId={propId}
                                                                                setCustomeFieldId={setPropId}
                                                                                statusColors={statusColors}
                                                                                handleRemoveCustomField={
                                                                                    handleRemoveCustomField
                                                                                }
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}

                                                            {col?.property?.name === 'Status' &&
                                                                (() => {
                                                                    const renderedTags =
                                                                        selectedFieldId && selectedFieldId.length > 0
                                                                            ? selectedFieldId
                                                                                .map((selectedField, SelectedIndex) => {
                                                                                    const label = getTagLabelByIdStatus(
                                                                                        filteredFieldDetails,
                                                                                        selectedField,
                                                                                    );
                                                                                    if (label) {
                                                                                        return (
                                                                                            <span
                                                                                                key={SelectedIndex}
                                                                                                className="text-xs rounded p-1 px-2 font-medium"
                                                                                                style={{
                                                                                                    color: 'white',
                                                                                                    background:
                                                                                                        getTagLabelColorByIdStatus(
                                                                                                            filteredFieldDetails,
                                                                                                            selectedField,
                                                                                                        ) || 'grey',
                                                                                                    borderRadius: '999px',
                                                                                                }}
                                                                                            >
                                                                                                {label}
                                                                                            </span>
                                                                                        );
                                                                                    }
                                                                                    return null;
                                                                                })
                                                                                .filter(Boolean)
                                                                            : [];

                                                                    return renderedTags.length > 0 ? (
                                                                        renderedTags
                                                                    ) : (
                                                                        <span>---</span>
                                                                    );
                                                                })()}

                                                            {col?.property?.name === 'Tag' &&
                                                                (() => {
                                                                    const renderedTags =
                                                                        selectedFieldId && selectedFieldId.length > 0
                                                                            ? selectedFieldId
                                                                                .map((selectedField, SelectedIndex) => {
                                                                                    const label = getTagLabelByIdTag(
                                                                                        filteredFieldDetails,
                                                                                        selectedField,
                                                                                    );
                                                                                    if (label) {
                                                                                        const color =
                                                                                            getTagLabelColorByIdTag(
                                                                                                filteredFieldDetails,
                                                                                                selectedField,
                                                                                            ) || '#2196f3';
                                                                                        return (
                                                                                            <span
                                                                                                key={SelectedIndex}
                                                                                                className="text-xs rounded p-1 px-2 font-medium"
                                                                                                style={{
                                                                                                    color: color,
                                                                                                    border: `1px solid ${color}`,
                                                                                                    borderRadius: '999px',
                                                                                                }}
                                                                                            >
                                                                                                #{label}
                                                                                            </span>
                                                                                        );
                                                                                    }
                                                                                    return null;
                                                                                })
                                                                                .filter(Boolean)
                                                                            : [];

                                                                    return renderedTags.length > 0 ? (
                                                                        renderedTags
                                                                    ) : (
                                                                        <span className="text-xs font-medium">---</span>
                                                                    );
                                                                })()}
                                                        </div>
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>

                    <div>
                        {filterIdeas && (
                            <div className="origin-top-right absolute mt-2 w-[18rem] rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 left-[318px] text-black">
                                <div className="max-w-xs p-4 bg-white border rounded shadow-lg">
                                    <div className="flex mb-4 justify-between border-b-4">
                                        <input type="text" className="w-full ideastask" />
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            className="bi bi-search text-[#696D72]"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                                        </svg>
                                    </div>
                                    <div className="space-y-2">
                                        <div className="border-b pb-2 text-black">
                                            <h2 className="font-semibold border-b-2 text-start">Personal Board</h2>
                                            <ul className="space-y-1 text-start mt-[12px] ml-[10px]">
                                                <li>To do</li>
                                                <li>Working on</li>
                                                <li>Follow up</li>
                                                <li>To Read</li>
                                                <li>Done</li>
                                            </ul>
                                        </div>
                                        <div className="border-b pb-2 text-black">
                                            <h2 className="font-semibold text-start">Project Board</h2>
                                            <ul className="space-y-1 text-start mt-[12px] ml-[10px]">
                                                <li>Ideas</li>
                                                <li>Planned</li>
                                                <li>In progress</li>
                                                <li>Done</li>
                                            </ul>
                                        </div>
                                        <button className="text-[#42B4F4]">Remove from board</button>
                                    </div>
                                </div>
                            </div>
                        )}
                        {listFilter && (
                            <div className="origin-top-right absolute mt-2 w-[18rem] rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 left-[318px] text-black">
                                <div className="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                                    <div className="flex ml-[18px] gap-[4px]">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            fill="currentColor"
                                            className="bi bi-arrow-up-short"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5" />
                                        </svg>
                                        <span>Sort ascending</span>
                                    </div>

                                    <div className="flex ml-[18px] gap-[4px]">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            fill="currentColor"
                                            className="bi bi-arrow-down-short"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4" />
                                        </svg>
                                        <span>Sort descending</span>
                                    </div>
                                    <div className="flex ml-[18px] gap-[4px]">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            fill="currentColor"
                                            className="bi bi-arrow-right-short"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8" />
                                        </svg>
                                        <span>Insert Custom Property at end</span>
                                    </div>

                                    <div className="border-t border-gray-100"></div>
                                    <div className="px-4 py-2">
                                        <div className="flex gap-[10px]">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16"
                                                height="16"
                                                fill="currentColor"
                                                className="bi bi-filter mt-[2px]"
                                                viewBox="0 0 16 16"
                                            >
                                                <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                                            </svg>
                                            <span className="text-[15px]">Filter</span>
                                        </div>

                                        <input
                                            type="text"
                                            name="filter"
                                            id="filter"
                                            placeholder="Type to Search"
                                            className="mt-1 block w-full px-3 py-2 border-[#BDBDBD] border-2 rounded-md placeholder-black  sm:text-sm"
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    {provided.placeholder}
                </div>
            )}
        </Droppable>
    );
};

export default TableData;
